<template>
  <div class="purchase-block f-column-b" :style="computedHeightStyle">
    <block-head :title="title" :subtitle="subtitle" :icon="icon" />
    <div class="list">
      <el-table
        v-if="list.length"
        class="project-table"
        height="200px"
        :data="list"
        fit
        :default-sort="{ prop: 'endTime', order: null }"
        :header-cell-style="headerCellStyle"
        :cell-style="cellStyle"
        @row-click="rowClick"
        ref="scrollTableP"
        @mouseenter.native="pauseScroll"
        @mouseleave.native="resumeScroll"
      >
        <el-table-column label="项目名称" min-width="180" header-align="center">
          <template slot-scope="{ row }">
            <div class="text-cut" :title="row.noticeTitle || row.gonggaoTitle">
              <span v-if="row.systemFrom === 'eip'" class="color-theme-red"
                >[自主采购]</span
              >
              {{ row.noticeTitle || row.gonggaoTitle }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="purchaseWayName"
          label="采购方式"
          width="210"
          align="center"
        />
        <el-table-column
          prop="startTime"
          label="公告时间"
          width="240"
          align="center"
        >
          <template #default="{ row }">
            <span>{{ (row.noticeTime || row.startTime) | parseTime("{y}-{m}-{d}") }}</span>
          </template>
        </el-table-column>
        <!--        <el-table-column v-if="!hidColumns.includes('endTime')" prop="endTime" label="截止时间" width="240" align="center" />-->
        <el-table-column label="项目状态" width="120" align="center">
          <template slot-scope="scope">
            <span
              class="table-btn"
              :style="{
                backgroundColor: ['1', '3'].includes(scope.row.status)
                  ? '#DC4B19'
                  : '#999',
              }"
              >{{ scope.row.status_name }}</span
            >
          </template>
        </el-table-column>
      </el-table>
      <no-data
        v-else
        :no-txt="noTxt"
        :no-img="noImg"
        :text="$attrs.text"
        img-width="100px"
        img-height="100px"
      />
    </div>
  </div>
</template>

<script>
import { PROJECT_STATUS_OPTIONS } from "@/utils/constant";
import purchaseApi from "@/api/purchase";
import NoData from "@/components/NoData.vue";
import BlockHead from "@/views/projectScroll/components/BlockHead.vue";

export default {
  name: "PurchaseBlock",
  components: { BlockHead, NoData },
  props: {
    icon: {
      type: String,
      default: "purchase",
    },
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    // 模块高度
    blockHeight: {
      type: [Number, String],
      default: "272px",
    },
    noTxt: {
      type: Boolean,
      default: true,
    },
    noImg: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 项目状态  未开始：0 报名中：1 报名截止：2 公示中：3 公示结束 ：4 已中标：5 已废标：6）
      statusList: Object.values(PROJECT_STATUS_OPTIONS),
      list: [],
      total: 0,
      scrollTimer: null,
      isScrolling: true, // 控制滚动状态
    };
  },
  // 监听属性 类似于data概念
  computed: {
    computedHeightStyle() {
      let height = this.blockHeight;
      if (typeof this.blockHeight === "string") {
        height = height.replace("px", "");
      }
      return { height: height + "px" };
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  async mounted() {
    await this.getList();
    this.$nextTick(() => {
      const divData = this.$refs.scrollTableP.bodyWrapper;
      divData.scrollTop = 0;
      this.startScroll();
    });
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    if (this.scrollTimer) {
      clearInterval(this.scrollTimer);
      this.scrollTimer = null;
    }
  },
  // 方法集合
  methods: {
    startScroll() {
      const divData = this.$refs.scrollTableP.bodyWrapper;
      this.scrollTimer = setInterval(() => {
        if (this.isScrolling) {
          divData.scrollTop += 1; // 关键：减少scrollTop以实现自下而上滚动
          // 判断是否滚动到顶部
          if (divData.scrollTop >= divData.scrollHeight - 175) {
            // 重置到容器底部，实现循环
            divData.scrollTop = 0;
          }
        }
      }, 30); // 滚动速度，数值越小滚动越快
    },
    pauseScroll() {
      this.isScrolling = false;
    },
    resumeScroll() {
      this.isScrolling = true;
    },
    // 获取列表
    async getList() {
      const params = {
        pageNo: 1,
        pageSize: 100,
        orderType: "default", // (默认：default  报名截止时间升序：baoMingEndDate_up 报名截止时间降序：baoMingEndDate_down)
        status: 1,
      };
      const res = await purchaseApi.page(params);
      if (res.code === 0) {
        const data = res.data || {};
        const list = data.list || [];
        this.total = data.total || 0;
        list.forEach((e) => {
          e.status_name = this.statusList.find(
            (f) => f.code === e.status
          )?.label;
        });
        this.list = data.list || [];
      }
    },
    headerCellStyle() {
      return "background-color: #f9f9f9;padding: 4px 0;";
    },
    cellStyle({ columnIndex, rowIndex }) {
      let str = "padding: 9px 0;cursor:pointer;";
      if (columnIndex === 4) {
        str += "display: flex;justify-content: center;";
      }
      if (rowIndex === (this.total - 1 > 0 ? this.total - 1 : 0)) {
        str += "border: none;";
      }
      return str;
    },
    // 行点击
    rowClick(row) {
      const route = this.$router.resolve({
        path: "/purchase/detail/xmxx",
        query: {
          id: row.id,
          infoid: row.infoid,
          noticeType: this.noticeType,
        },
      });
      window.open(route.href);
    },
  },
};
</script>

<style scoped lang="scss">
.block-head {
  margin: 0;
  ul > li {
    cursor: pointer;
    &.active {
      color: $--color-primary;
      font-weight: bold;
    }
    &:hover {
      color: $--color-primary;
    }
  }
}
.purchase-block {
  width: 100%;
  .list {
    flex: 1;
    min-height: 0;
    border: 1px solid #ddd;
    .project-table {
      &::before {
        height: 0;
      }
      .table-btn {
        display: inline-block;
        width: 70px;
        height: 23px;
        line-height: 23px;
        color: #fff;
        text-align: center;
      }
    }
  }
}
</style>
